import { Theme, Alert } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { useAppSelector } from '../app/hooks';
import TaskRouterBody from '../components/TaskRouterBody';
import { selectWSConnectionMessage } from '../redux/features/taskRouter/taskRouter.selector';
import logger from '../utils/logger';

const useStyles = makeStyles<Theme>(({ spacing }) => ({
  taskRouterPageClass: {},
  alertClass: {
    position: 'absolute',
    left: spacing(2),
    right: spacing(2),
    zIndex: 200,
    alignItems: 'center',
  },
}));

const TaskRouterPage = () => {
  const { taskRouterPageClass, alertClass } = useStyles();
  const {
    handleAgentAvailability,
    sendTaskMessage,
    initializeTaskRouter,
    isTaskAssignmentMode,
  } = useOutletContext<any>();
  const wsConnectionMessage = useAppSelector(selectWSConnectionMessage);

  useEffect(() => {
    logger.info({
      message: 'Task-router page component is mounted',
      isTR: true,
    });
    initializeTaskRouter();
  }, []);

  return (
    <div data-testid="task-router-page" className={taskRouterPageClass}>
      {wsConnectionMessage ? (
        <Alert variant="filled" severity="error" className={alertClass}>
          {wsConnectionMessage}
        </Alert>
      ) : (
        <TaskRouterBody
          handleAgentAvailability={handleAgentAvailability}
          sendTaskMessage={sendTaskMessage}
          isTaskAssignmentMode={isTaskAssignmentMode}
        />
      )}
    </div>
  );
};

export default TaskRouterPage;
